module.exports = __webpack_public_path__ + "img/final-page.2f8211fa.svg";